import { Component, inject } from '@angular/core';
import { SpinnerService } from '../../services/spinner.service';

/** Overlay bloqueante global. Solo se muestra durante mutaciones. */
@Component({
  selector: 'app-spinner',
  imports: [],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
})
export class SpinnerComponent {
  protected readonly spinnerService = inject(SpinnerService);
}
